module.exports = __webpack_public_path__ + "static/media/ill_nagelsvamp.3d04bd2a.svg";